import { ReactNode, useState } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { Visible } from "util/enhancer";
import { ReactComponent as CrossIcon } from "../../assets/cross.svg";
import { ReactComponent as TooltipIcon } from "../../assets/tooltipInfo.svg";

type DataTooltipProps = {
  id: string;
  text: ReactNode;
};

export const Tooltip = ({ id, text }: DataTooltipProps) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const onClose = () => setTooltipOpen(!tooltipOpen);

  return (
    <div>
      <button
        type="button"
        className="zb-button tooltip-target"
        id={id}
        onClick={onClose}
        aria-label={id}
        aria-describedby={`tooltip-${id}`}
      >
        <TooltipIcon focusable="false" />
      </button>
      <UncontrolledTooltip
        placement="bottom-end"
        isOpen={tooltipOpen}
        target={id}
        toggle={onClose}
        trigger="click"
        id={`tooltip-${id}`}
      >
        <button
          type="button"
          className="zb-button tooltip-close"
          role="button"
          aria-label="Close"
          onClick={onClose}
        >
          <CrossIcon focusable="false" />
        </button>
        {text}
      </UncontrolledTooltip>
    </div>
  );
};

export const VisibleToolTip = Visible(Tooltip);
